<template>
  <div class="waitingEvaluate">
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh" >
      <i class="iconfont icon-educesuan-icon topicon"></i>
      <p class="tip">系统评估中……</p>
      <p class="smallTip">
        正在对您提供的信息进行评估
      </p>
      <div class="box"></div>
    </van-pull-refresh>
  </div>
</template>

<script>
/**
 * 等待初审结果页面
 */
// @ is an alias to /src
import { checkStatus } from './mixin';

export default {
  name: 'IdentifyTesting',
  data() {
    return { isLoading: false };
  },
  beforeCreate() {
    document.querySelector('body').setAttribute('style', 'background-color:#fff');
  },
  mixins: [checkStatus],
  methods: {
    onRefresh() {
      setTimeout(() => {
        this.$store.dispatch('commonForms/checkCurrentStatus', { getInfo: false });
        this.isLoading = false;
      }, 500);
    },
  },
  mounted() {
    this.interval = setInterval(() => {
      this.$store.dispatch('commonForms/checkCurrentStatus', { getInfo: false });
    }, 5000);
  },
  destroyed() {
    clearInterval(this.interval);
  },
  beforeDestroy() {
    document.querySelector('body').removeAttribute('style');
  },
};
</script>
<style scoped>
.bgColor {
  height: 100%;
  background-color: #fff;
}
.van-loading__spinner--spinner i::before {
  width: 4px;
  border-radius: 2px;

}
.waitingEvaluate {
  height: 100%;
}
.tip {
  color: #1c2438;
  font-size: 17px;
  letter-spacing: 0;
  text-align: center;
}
.smallTip {
  color: #9ea7b4;
  font-size: 14px;
  letter-spacing: 0;
  text-align: center;
}
.box {
  width: 100%;
  height: 200px;
}
.topicon {
  display: block;
  padding-top: 103px;
  color: #F65249;
  font-size: 60px;
}
</style>
